export const getMenuItemsAdm = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Baixar" },
    { key: "2", label: "Autenticar" },
    { key: "3", label: "Excluir" },
    { key: "4", label: "Bloquear exclusão" },
  ];
};

export const getMenuItemsProp = () => {
  // Items do menu ação
  return [
    { key: "1", label: "Baixar" },
    { key: "3", label: "Excluir" },
  ];
};
